module.exports = __webpack_public_path__ + "img/header-engagementRingsCollectionRings@2x.69e16de.webp";